export function init($name = '') {
    const boxes = $($name);

    if (!boxes.length) {
        return;
    }

    boxes.each(function() {
        const button = $(this).find('button');

        if (button.length !== 1) {
            return;
        }

        $(this).attr('onclick', button.attr('onclick')).addClass('cursor-pointer');

        if (button.hasClass('is-hidden')) {
            $('<div class="show-content-button"></div>').insertAfter(button);
        }
    });
}

